<template>
  <q-layout view="hHh Lpr lff">
    <q-header
      elevated
      class="q-pt-xs"
      :class="$q.dark.mode === true ? 'dark' : 'bg-white'"
    >
      <q-toolbar
        class="justify-between"
        :class="$q.dark.mode === true ? 'bg-grey-9' : 'text-primary'"
      >
        <div class="flex flex-start no-wrap">
          <q-btn
            flat
            dense
            round
            icon="menu"
            aria-label="Menu"
            @click="toggleLeftDrawer"
          />
          <q-toolbar-title class="gt-xs">
            <div
              class="title cursor-pointer"
              clickable
              @click="$router.push('/')"
            >
              <q-icon name="meeting_room" class="q-pa-xs q-mb-xs" />Chukul
            </div>
          </q-toolbar-title>
          <q-toolbar-title class="sm-xs xs">
            <div
              class="title cursor-pointer"
              clickable
              @click="$router.push('/')"
            >
              <q-icon name="meeting_room" class="q-pa-xs q-mb-xs" />
            </div>
          </q-toolbar-title>
        </div>

        <SearchBar />

        <div class="row no-wrap">
          <q-avatar dense>
            <q-icon
              dense
              clickable
              @click="$router.push('/video-tutorial')"
              size="sm"
              name="help"
              class="cursor-pointer"
            >
              <q-tooltip class="bg-primary"> Video Tutorial </q-tooltip>
            </q-icon>
          </q-avatar>
          <q-toggle
            v-model="themeToggle"
            @update:model-value="toggleThemeFunction"
            checked-icon="light_mode"
            unchecked-icon="dark_mode"
          >
            <q-tooltip content="Uesr-Profile" class="bg-primary">
              Toggle Themes
            </q-tooltip></q-toggle
          >

          <NotificationBell
            v-if="this.$store.state.authenticate.isAuthenticated"
            class="q-mr-md-md q-mr-sm-sm q-mr-xs-xs"
          />

          <UserDropdown
            v-if="
              this.$store.state.authenticate.isAuthenticated && userProfiles
            "
            :whoAmI="$store.state.accounts.whoAmI"
            class="q-mr-md-md q-mr-sm-sm q-mr-xs-xs"
          />
          <q-btn
            v-if="!this.$store.state.authenticate.isAuthenticated"
            v-show="!urlToken"
            color="primary"
            class="q-ma-sm"
            size="sm"
            label="Login"
            no-caps
            :to="{
              name: 'Login',
            }"
          />
        </div>
      </q-toolbar>
    </q-header>

    <q-drawer v-model="leftDrawerOpen" show-if-above bordered :width="255">
      <q-scroll-area class="fit">
        <MainMenu :market="isMarketOn" :key="isMarketOn" />
      </q-scroll-area>
    </q-drawer>

    <q-page-container>
      <div class="q-mx-sm">
        <MobileAppUpdate />

        <q-dialog v-model="confirm" persistent>
          <q-card>
            <q-bar class="bg-grey-3 text-white">
              <q-space />
              <q-btn
                v-close-popup
                text-color="white"
                color="red"
                dense
                size="sm"
                icon="close"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>
            <q-card-section class="row items-center">
              <q-img
                class="text-center cursor-pointer"
                style="
                  height: 70vw;
                  max-height: 500px;
                  width: 70vw;
                  max-width: 500px;
                  text-align: center;
                "
                @click="$router.push({ name: 'TraderMeet' })"
                src="images/trader_meet_bannar.jpg"
              />
            </q-card-section>

            <q-card-actions align="right">
              <q-btn
                label="Click to find details"
                @click="$router.push({ name: 'TraderMeet' })"
                color="primary"
                v-close-popup
              />
              <q-btn flat label="Cancel" color="red" v-close-popup />
            </q-card-actions>
          </q-card>
        </q-dialog>

        <q-dialog
          v-if="this.$store.state.authenticate.isAuthenticated"
          v-model="verifyEmailDialog"
          persistent
          square
        >
          <q-card style="max-width: 95vw">
            <q-card-section class="bg-primary text-white">
              <q-bar class="bg-primary text-white" style="min-height: 3vh">
                <div class="text-h6">Update Details</div>
                <q-space></q-space>
                <q-btn
                  class="q-px-xs q-mx-sm"
                  v-close-popup
                  text-color="white"
                  color="red"
                  dense
                  size="sm"
                  icon="close"
                  @click="onClickIsSignup"
                >
                  <q-tooltip class="bg-white text-primary">Close</q-tooltip>
                </q-btn>
              </q-bar>
            </q-card-section>
            <q-card-section>
              <p class="q-pl-sm">
                Please verify your email address.To activate Demo Package
                <span class="text-negative text-weight-bolder">*</span>
              </p>
              <SettingDialog
                :settingDialog="true"
                @closeModel="verifyEmailDialog = false"
              />
            </q-card-section>
          </q-card>
        </q-dialog>

        <q-banner
          rounded
          dense
          inline-actions
          :class="
            this.$q.dark.mode
              ? 'q-mt-sm bg text-white text-caption'
              : 'q-mt-sm bg-primary text-white text-caption'
          "
          v-if="!isEmailVerified && emailBanner"
        >
          Please verify your email address.
          <template v-slot:action>
            <q-btn
              flat
              color="white"
              label="Dismiss"
              class="text-caption text-bold"
              no-caps
              @click="emailBanner = false"
            />
            <q-btn
              flat
              color="white"
              label="Verify Email"
              class="text-caption text-bold"
              no-caps
              v-on:click="
                $router.push({ name: 'Settings', query: { emailFocus: true } })
              "
            />
          </template>
        </q-banner>

        <q-banner
          inline-actions
          class="q-mt-sm bg-primary text-white"
          v-if="days <= reminderDays && packageBanner"
        >
          {{ packageMessage }}
          <template v-slot:action>
            <q-btn
              flat
              color="white"
              label="Dismiss"
              @click="packageBanner = false"
            />
            <q-btn
              flat
              color="white"
              label="Renew Package"
              @click="$router.push({ name: 'Payment' })"
            />
          </template>
        </q-banner>
      </div>
      <SymbolDetailList />

      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { LocalStorage } from "quasar";
import {
  defineComponent,
  ref,
  computed,
  onBeforeMount,
  onMounted,
  watch,
} from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import useAccounts from "src/use/accounts";
import useMembership from "src/use/membership";
import useMarket from "src/use/market";
import MainMenu from "src/components/header/MainMenu.vue";
import SearchBar from "src/components/header/SearchBar.vue";
import NotificationBell from "src/components/header/NotificationBell.vue";
import UserDropdown from "src/components/header/UserDropdown.vue";
import MobileAppUpdate from "src/components/MobileAppUpdate.vue";
import SymbolDetailList from "src/components/SymbolDetailList.vue";
import SettingDialog from "src/pages/Settings.vue";
export default defineComponent({
  name: "MainLayout",
  components: {
    MobileAppUpdate,
    NotificationBell,
    MainMenu,
    UserDropdown,
    SearchBar,
    SymbolDetailList,
    SettingDialog,
  },
  setup() {
    const { whoAmI } = useAccounts();
    const { getPackage } = useMembership();
    const { marketTime } = useMarket();
    const store = useStore();
    const $q = useQuasar();
    let urlToken = ref(window.location.search.includes("token="));
    const leftDrawerOpen = ref(false);
    const confirm = ref(false);
    const packageDetail = ref({});
    const packageMessage = ref("");
    const isEmailVerified = ref(null);
    const packageBanner = ref(null);

    const emailBanner = ref(null);
    const verifyEmailDialog = ref(false);
    let themeToggle = ref(true);
    const computedThemeToggle = computed(() => {
      if (themeToggle.value) {
        return false;
      } else {
        return true;
      }
    });
    const isSignup = ref(false);
    isSignup.value = LocalStorage.getItem("isSignup");

    const getGeneralMenu = () => {
      store.dispatch("menu/getGeneralMenu");
    };
    const getFavouriteMenu = () => {
      store.dispatch("menu/getFavouriteMenu").then(() => {
        getGeneralMenu();
      });
    };
    if (store.state.authenticate.isAuthenticated) getFavouriteMenu();

    onMounted(() => {
      let isDarkTheme = LocalStorage.getItem("darkTheme");
      if (isDarkTheme) {
        $q.dark.set(true);
        themeToggle.value = false;
      } else {
        $q.dark.set(false);
        themeToggle.value = true;
      }
      if (store.state.authenticate.isAuthenticated)
        if (store.state.accounts.whoAmI) {
          if (!store.state.accounts.whoAmI.is_email_verified) {
            userProfiles.value = store.state.accounts.whoAmI;
            // emailBanner.value = true;
            // dialog.value = true;
            if (isSignup.value) {
              verifyEmailDialog.value = true;
            }
            isEmailVerified.value = false;
          }
        } else {
          store.dispatch("accounts/whoAmI").then((res) => {
            userProfiles.value = store.state.accounts.whoAmI;
            isEmailVerified.value =
              store.state.accounts.whoAmI.is_email_verified;
            if (isSignup.value) {
              verifyEmailDialog.value =
                !store.state.accounts.whoAmI.is_email_verified;
            }
          });
        }
    });

    watch(
      () => $q.dark.mode,
      (newVal, oldVal) => {
        // To toggle button when clicked in Trading view Theme(Dark/Light) Button
        themeToggle.value = !newVal;
      }
    );

    let reminderDays = 4;
    const days = ref(null);
    const userProfiles = ref([]);
    if (store.state.authenticate.isAuthenticated) {
      // if (LocalStorage.getItem("package") == null) {
      getPackage()
        .then(async (res) => {
          packageDetail.value = res.data;
          LocalStorage.set("package", res.data);
          if (res.status === 200) {
            if (res.data?.message) {
              packageMessage.value = res.data.message;
            } else if (res.data?.expiry_date) {
              emailBanner.value = false;
              var start = new Date();
              var end = new Date(res.data?.expiry_date);
              days.value = 1 + parseInt((end - start) / 1000 / 60 / 60 / 24);
              if (days.value <= reminderDays) {
                packageMessage.value = `Your package will expire in ${days.value} days`;
                packageBanner.value = true;
              }
              if (days.value <= 0) {
                packageMessage.value = `Your package has expired on ${res.data?.expiry_date}`;
                packageBanner.value = true;
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
      // } else {
      //   packageDetail.value = LocalStorage.getItem("package");
      // }
    }
    const isMarketOn = ref(false);
    const currentTimeNepal = ref(null);
    const getNepalTime = (date = null) => {
      if (!date) date = new Date();
      return new Date(
        (typeof date === "string" ? new Date(date) : date).toLocaleString(
          "en-US",
          { timeZone: "Asia/Kathmandu" }
        )
      );
    };
    currentTimeNepal.value = getNepalTime();

    const marketCheck = () => {
      if (store.state.market.marketStatus) {
        isMarketOn.value = true;
        LocalStorage.set("isMarketOn", true);
      } else {
        isMarketOn.value = false;
        LocalStorage.set("isMarketOn", false);
      }
    };
    setInterval(() => {
      marketCheck();
    }, 1000);

    function onClickIsSignup() {
      LocalStorage.set("isSignup", false);
      isSignup.value = false;
    }

    function toggleThemeFunction() {
      if ($q.dark.mode) {
        $q.dark.set(false);
        LocalStorage.set("darkTheme", false);
      } else {
        $q.dark.set(true);
        LocalStorage.set("darkTheme", true);
      }
    }
    return {
      urlToken,
      userProfiles,
      leftDrawerOpen,
      isEmailVerified,
      days,
      reminderDays,
      packageMessage,
      packageBanner,
      emailBanner,
      isMarketOn,
      verifyEmailDialog,
      onClickIsSignup,
      toggleLeftDrawer() {
        leftDrawerOpen.value = !leftDrawerOpen.value;
      },
      toggleThemeFunction,
      themeToggle,
      confirm,
    };
  },
});
</script>
